import React from 'react';
import './App.css';
import MainLayout from './layout/MainLayout';
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import RecoverPassword from './pages/auth/ConfirmForgotPassword';
import { AuthProvider, useAuth } from './providers/AuthContext';
import { ZoneProvider } from './providers/ZoneContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, useLocation, Navigate } from 'react-router-dom';
import './lib/api';


const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60_000,
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});
const ENVIRONMENT_PREFIXES = [
    { prefix: 'test', name: 'test' },
    { prefix: 'qa', name: 'QA' },
    { prefix: 'es', name: 'ES' },
    { prefix: 'pt', name: 'PT' },
    { prefix: 'lvl', name: 'production' },
    { prefix: 'localhost', name: 'local' }
];

function removeProtocol(url) {
    return url.replace(/^https?:\/\//, '');
}

function getEnvironmentName(url) {
    for (const { prefix, name } of ENVIRONMENT_PREFIXES) {
        if (url.startsWith(prefix)) {
            return name;
        }
    }
    return null;
}

function validateEnvironmentMatch(environment, url) {
    if (!environment) {
        throw new Error("REACT_APP_ENVIRONMENT is not set.");
    }

    for (const { prefix, name } of ENVIRONMENT_PREFIXES) {
        if (environment.startsWith(prefix) && !url.startsWith(prefix)) {
            throw new Error(
                `You are trying to access the ${name} environment, but the URL does not start with '${prefix}'. Please use the correct URL.`
            );
        }
    }
}

function AppContent() {
    const { isAuthenticated, user, checkAuth } = useAuth();
    const environment = removeProtocol(process.env.REACT_APP_BACKEND_URL);
    const url = removeProtocol(window.location.href);
    const location = useLocation();

    validateEnvironmentMatch(environment, url);
    window.APP_ENVIRONMENT = getEnvironmentName(url);

    if (isAuthenticated === null || (isAuthenticated && !user)) {
        return <p>Verificando autenticação...</p>;
    }

    let external_page = <Login onLogin={checkAuth} />

    if (location.pathname === '/forgotPassword')
        external_page = <ForgotPassword />;
    else if (location.pathname === '/confirmForgotPassword')
        external_page = <RecoverPassword />;

    return (
        <div className="App">
            {isAuthenticated ? (
                <ZoneProvider>
                    <main>
                        <header className="App-header">
                            {location.pathname === '/' ? <Navigate to="/stock" replace /> : null}
                            <MainLayout />
                        </header>
                    </main>
                </ZoneProvider>
            ) : (
                external_page
            )}
        </div>
    );
}

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <BrowserRouter>
                    <AppContent />
                </BrowserRouter>
            </AuthProvider>
        </QueryClientProvider>
    );
}

export default App;
